//  Get the current station configuration ListingStatus
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getListingStatus = function(params) {
    return this.axiosIns.get('/api-site/snapshot/listing-status', { params });
};
//  according to listingStatus Get property data 
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getSnapshotListing = function(params, page) {
    // if (
    //     window.sitePageAutoInit === false &&
    //     page.pageKey === 'listing-detail-sold' &&
    //     !page.isLandingPage
    // ) {
    //     return import(
    //         /* webpackChunkName: "listing_list_mock"*/ './cms-mock'
    //     ).then(res => {
    //         //  right   result in a deep copy 
    //         return Promise.resolve(JSON.parse(JSON.stringify(res)));
    //     });
    // }
    return this.axiosIns.get(`/api-site/snapshot/listings`, { params });
};
